module.exports = __webpack_public_path__ + "static/media/A1.9e205cb4.png";